import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./pricing.css";

const PricingCards = () => {
  const [currency, setCurrency] = useState("INR");
  const [exchangeRate, setExchangeRate] = useState(1);

  // Price in INR
  const prices = {
    professional: 8500,
    premium: 18000, 
    singleEvent: 30000,
  };

  useEffect(() => {
    axios.get("https://ipapi.co/json/")
      .then(response => {
        const country = response.data.country;
        let currencyCode = "INR";

        if (country === "CA") currencyCode = "CAD";
        else if (country === "US") currencyCode = "USD";
        else if (country === "GB") currencyCode = "GBP";

        setCurrency(currencyCode);
        fetchExchangeRate(currencyCode);
      })
      .catch(error => console.error("Error fetching location:", error));
  }, []);

  const fetchExchangeRate = (toCurrency) => {
    axios.get(`https://api.exchangerate-api.com/v4/latest/INR`)
      .then(response => {
        const rate = response.data.rates[toCurrency] || 1;
        setExchangeRate(rate);
      })
      .catch(error => console.error("Error fetching exchange rate:", error));
  };

  return (
    <div className="pricing-table-container" style={{marginTop: "60px"}}>
      <table className="pricing-table">
        <thead>
          <tr>
            <th className="feature-column">
              <div className="compare-section">
                <h4>Pricing 🍃</h4>
                <p>Choose your workspace plan according to your organizational need.</p>
              </div>
            </th>
            <th>
              <div className="pricing-header">
                <div className="event-type">
                  <h2>Explorer</h2>
                  <div className="billed-text" >
                    <span style={{ padding: "5px" }}>No Cost</span>
                  </div>

                </div>
                {/* <button className="choose-plan-btn" style={{ marginTop: "56px" }}>Choose This Plan</button> */}
              </div>
            </th>
            <th>
              <div className="pricing-header">
                <div className="event-type">
                  <h2>Professional</h2>
                  <div className="billed-text">
                  <span>{Math.round(prices.professional * exchangeRate)} {currency}/month</span>
                  </div>
                  <h4 style={{ marginTop: "20px", marginLeft:"75px" }}>Billed Annually</h4>
                </div>
                
              
                {/* <button className="choose-plan-btn">Choose This Plan</button> */}
              </div>
            </th>
            <th>
              <div className="pricing-header">
                <div className="event-type">
                  <h2>Premium</h2>
                  <div className="billed-text">
                  <span>{Math.round(prices.premium * exchangeRate)} {currency}/month</span>
                   
                  </div>
                  <h4 style={{ marginTop: "20px",  marginLeft:"80px" }}>Billed Annually</h4>
                </div>
                {/* <button className="choose-plan-btn">Choose This Plan</button> */}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Participants</td>
            <td>100</td>
            <td>1000</td>
            <td>1000 & Above</td>
          </tr>
          <tr>
            <td>Carbon Emission Estimation</td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>No. of Events</td>
            <td>1</td>
            <td>6</td>
            <td>24</td>
          </tr>
          <tr>
            <td>Automated Email Notifications</td>
            <td>100 emails</td>
            <td>3000 emails</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td>Report Generation & Downloading</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>AI-Powered Advisory</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>Consulting for Carbon Neutral Event</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>Report Validation Options</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>Carbon Offset Plans</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>API Access</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
          <tr>
            <td>API Integration Support</td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faXmark} /></td>
            <td><FontAwesomeIcon icon={faCheck} /></td>
          </tr>
        </tbody>
      </table>

      <div className="single-event">
        <h4>Or You may select per event basis</h4>
        <p>
          <b>Single Event Plan:</b> <i>{Math.round(prices.singleEvent * exchangeRate)} {currency}</i>(All facilities of Premium Level Plan for 1 event only)
          <br />
          <b>Customized Plan:</b> Send your enquiry to 📧 <a href="mailto:connect@ecoindex.ai">connect@ecoindex.ai</a> to get a quote.
        </p>
      </div>
    </div>
  );
};

export default PricingCards;
